import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Form, Button, Container } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import connect from '../assets/images/Connect.png';
import './SignUp.css';
import axios from 'axios';

function Connect2() {
    const navigate = useNavigate();
    const location = useLocation();
    const [mfa_code, setMFA] = useState('');
    const [token, setToken] = useState('');

    const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

    const handleConnect = async (event) => {
        event.preventDefault();

        const previousResponse = location.state && location.state.previousResponse;
        
        if (!previousResponse) {
             alert("Session invalid. Please try again.");
             navigate("/connect");
             return;
        }

        const payload = {
            mfa_url: previousResponse.mfa_url,
            idp_session: previousResponse.idp_session,
            authenticity_token: previousResponse.authenticity_token,
            sp_issuer: previousResponse.sp_issuer,
            form_parameters: previousResponse.form_parameters,
            mfa_code: mfa_code
        };

        try {
            const response = await axios.post(`${API_ENDPOINT}/api/globalentry/mfa/`, payload);

            if (response.status === 200) {
                const receivedToken = response.data.token;
                setToken(receivedToken);
                localStorage.setItem('token', receivedToken);
                navigate("/connect3");
            }
        } catch (error) {
            alert("Failed to connect. Please check your MFA code and try again.");
        }

    };

    useEffect(() => {
        
    }, []);

    return (
        <div className="signup-page">
            <Helmet>
                <title>Enter MFA Code</title>
                <meta name="description" content="Enter your Login.gov two-factor authentication code to complete the connection process." />
                <link rel="canonical" href="https://www.easyglobalentry.com/connect2" />
            </Helmet>
            <Container className="signup-container2">
                <img src={connect} className='connect-img' alt="Connect" />
                <h1 className="center-text" style={{ fontSize: '2rem' }}>Connect to Login.gov</h1>
                <div className="disclaimer">
                    We require your Login.gov information to automatically book on your behalf. To learn more please see our <a href="/privacy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>.
                </div>
                <p></p>
                <Form onSubmit={handleConnect}>
                    <Form.Group className="mb-3" controlId="formEmail">
                        <Form.Label className="bold-label">Login.gov Two-Factor Authentication Code</Form.Label>
                        <Form.Control value={mfa_code} onChange={e => setMFA(e.target.value)} required/>
                    </Form.Group>


                    <div className="center-text">
                        <Button variant="primary" type="submit" className="btn-block custom-button">
                            Connect
                        </Button>
                    </div>
                </Form>
            </Container>
        </div>
    );
}

export default Connect2;